<template>
<div class="titlescreen">
    <h1>Arcade Kombat Fighter</h1>
    <h2>C'est quoi ce ce jeu ?</h2>
    <p>"Arcade Kombat Fighter" est un jeu codé pour la VideoGamesLab GameJam 2021 ! Le thème était "ARCADE". Perso, j'associe l'arcade aux jeux de baston et j'ai choisi de faire mon jeu autour d'une borne d'arcade qui se bastonne avec d'autres bornes, mais au tour par tour, d'où "Arcade Kombat Fighter" !</p>
    <h2>Instructions</h2>
    <p>Dans "Arcade Kombat Fighter" vous jouez le rôle d'une borne d'arcade vivante qui doit se battre contre d'autres bornes d'arcades. Pour ce faire, vous avez à votre disposition plusieurs boutons, qu'ils vous faudra combiner pour sortir des coups.</p>
    <p>Seulement, quelles combinaisons faire ? He bien cela c'est à vous de la découvrir ! Un indice tout de même : les classiques du versus fighting (et du retro gaming en général) sont présents ! </p>
    <p>Oh, et vous perdrez des crédits à chaque attaque de votre adversaire, alors pensez à remettre des pièces de temps en temps !</p>
    <button @click="$emit('launch')">Lancer le jeu</button>
</div>
</template>

<script>
export default {
    name: "TitleScreen"
}
</script>

<style lang="scss" scoped>
.titlescreen {
    display: flex;
    flex-direction: column;
    background-color: white;
    padding: 1rem;
    h1 {
        font-size: 3rem;
        font-weight: 900;
        font-style: italic;
        color: white;
        background-color: black;
        padding: 0 0.5rem 0.2rem 0.5rem;
        margin: auto;
        margin-bottom: 3rem;
    }
    h2 {
        color: white;
        background-color: black;
        padding: 0 0.5rem 0.2rem 0.5rem;
    }
    button {
        font-size: 2rem;
        color: white;
        background-color: black;
        padding: 0 0.5rem 0.2rem 0.5rem;
        margin: auto;
        margin-top: 3rem;
        border: none;
        transition: all 0.2s ease-in-out;
        &:hover {
            background-color: darkgray;
            cursor: pointer;
        }
        &:active {
            color: black;
            background-color: white;
        }
    }
}

</style>